// extracted by mini-css-extract-plugin
export default {"base":"EditAuthorName_base__Axjh4","label":"EditAuthorName_label__+I5VS","field":"EditAuthorName_field__5POTL"};